export type ParsedStorageDataType = {
  tapCount: number; // 유저 토탈 탭 카운트
  adTapCount: number; // 광고 노출용 탭 카운트
  fontSize: number;
  autoplaySpeed: number;
  hasEditorGuideViewed: boolean;
  latestSearchList: string[];
  annualReport2022Commented: boolean;
  annualReport2022MessageSent: boolean;
  hasBookingPeriodChangeViewed: boolean;

  // instant
  showabledEstimatedRevenueDate: number;

  hasPublishNowTooltipViewed: boolean;
  lastAppliedWithdrawal: { value: string };
  hasWaitfreeBreakawayModalViewed: boolean;

  hideAppReviewUntil: number;
  interstitialAdPriorityDay: number;
  hideAdSkipModalUntil: number;

  trackTapCount200: boolean;
  trackTapCount500: boolean;
  trackTapCount3000: boolean;
  isCharacterNameLengthToolTipShow: boolean;

  mockDate: {
    date: string | undefined | null | Date;
  };

  //ai test
  isSkipFreeChat: boolean;
  hasUsedFreeChat: boolean;
  hasUsedChatIntro: boolean;
  hasPurchasedUser: boolean;
  hasPurchasedUserv2: boolean;
  hasPurchasedUserv3: boolean;
  hasPurchasedUserv4: boolean;
  hasUsedPaidChatv2: boolean;
  hasUsedFreeChatPerUUIDv2: string[] | undefined;
  hasSendFreeChatPerUUIDv2: string[] | undefined;
  shouldRefresh: string;
  shownChatStoryIds: string[];
  hasArrivedTutorial: boolean;
  emailVerification: number;
  hasChatEditorGuideViewed: boolean;
  hasProfileCoachViewed: boolean;
  hasNotShowMoreSnapShotCoachMark: boolean;
  hasNotShowAdultCoachMarkV2: boolean;
  hasSeenAiBgAlert: string[];
  isNotShowChristMasModalDate: string;
  hasShownDeleteCoach: boolean;
  lastPeekTabViewDate: Date;
  firstPeekActivatedDate: string;
  hasShownPrvCoachMark: boolean;
  hookingModalWatechedDate: string;
  hasHelpGuideViewedV2: boolean;
  hasWatchedPlotRecommendPrice: boolean;
  hasWatchedPlotDevelopmentPrice: boolean;
  //inflow
  inflow: string;
  nowShowRecommendDate: string;
  hasUsedPlotRecommend: boolean;
  hasUsedPlotDevelopment: boolean;
  devDriveBannerCnt: number;
  hasShownDevEventTooltip: boolean;
  selectedSectionTab: {
    [key: string | number]: string | number;
  };
  playInduceCloseCount: string;
  playInduceNotShowDate: Date;
  hasProceedSnapShotV2: boolean;
  freeMessageBadgeClosedDate: number;
  hasWatchedMarketToolTip: boolean;
  hasWatchedCreateVisualPrice: boolean;
  hasWatchedImageGenerationPrice: boolean;
  hasWatchedImageGeneration: boolean;
  watchedVisualModalNumber: number;
  hasWatchedChemingCoachMark: boolean;
  isNotShowViewerScrollModeTooltip: boolean;
  episodeChatModalUntil: number;
  freeEpisodeChatCount: number;
  hasSeenColorChangeTip: boolean;
  hasSeenMultiImageTip: boolean;
};

export class ParsedStorage {
  static getItem = <K extends keyof ParsedStorageDataType>(
    key: K,
    identifier?: number | string
  ): ParsedStorageDataType[K] | null => {
    const keyWithIdentifier = identifier ? `${key}:${identifier}` : key;

    const item = localStorage.getItem(keyWithIdentifier);
    return item ? JSON.parse(item) : null;
  };

  static setItem = <K extends keyof ParsedStorageDataType>(
    key: K,
    data: ParsedStorageDataType[K],
    identifier?: number | string
  ) => {
    const keyWithIdentifier = identifier ? `${key}:${identifier}` : key;

    if (typeof data !== 'string') {
      localStorage.setItem(keyWithIdentifier, JSON.stringify(data));
    } else {
      localStorage.setItem(keyWithIdentifier, data);
    }
  };

  static removeItem = <K extends keyof ParsedStorageDataType>(
    key: K,
    identifier?: number | string
  ) => {
    const keyWithIdentifier = identifier ? `${key}:${identifier}` : key;

    localStorage.removeItem(keyWithIdentifier);
  };
}
